import { useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  FormGroup,
  FormLabel,
  TextField,
  FormControlLabel,
  Switch,
  Tooltip,
  IconButton,
  OutlinedInput,
  Divider,
  LinearProgress,
} from "@material-ui/core";

import DeleteIcon from "@mui/icons-material/Delete";

import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { columnTextField } from "utils/tables-utils";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import UtilsFncs from "utils/UtilsFncs";
import StructureFields from "components/_refactor/fields/structure";
import TableProductsList from "./table-products-list";
import useLogs from "hooks/logs";

import componentButtonStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import FromToDateField from "components/_refactor/fields/from-to-date";
import { IsMobile900 } from "utils/is-mobile";
import { IsMobile } from "utils/is-mobile";
import { IsMobile500 } from "utils/is-mobile";

const useComponentStyles = makeStyles(componentButtonStyles);

export default function DialogEditShowcase({ data, filter, handleClose }) {
  const classes = { ...useComponentStyles() };
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const isMobile900 = IsMobile900();
  const isMobile700 = IsMobile();
  const isMobile500 = IsMobile500();

  const itemXS = isMobile700 ? 12 : isMobile900 ? 6 : 4;
  const itemSM = isMobile700 ? 12 : 6;

  const [showcaseName, setShowcaseName] = useState(data?.Nome);
  const [active, setActive] = useState(data?.Ativo);
  const [initialDate, setInitialDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [productsList, setProductsList] = useState([]);

  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [showAddProductsContainer, setShowAddProductsContainer] =
    useState(false);

  const [productFilter, setProductFilter] = useState("");

  const [searchingProducts, setSearchingProducts] = useState(false);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showcaseItemsList, setShowcaseItemsList] = useState([]);

  const [editingShowcase, setEditingShowcase] = useState(false);

  const handleGetProducts = async ({ page = 1, showcaseList = [] }) => {
    setSearchingProducts(true);

    await Api.get(
      "product-simple-list",
      "product",
      "?page=" +
        (page - 1) +
        `&pageSize=10` +
        "&order=D" +
        "&filter=" +
        productFilter +
        "&idMarca=" +
        filter?.idMarca?.toString() +
        "&idPessoaLoja=" +
        structureFilters?.idLojaUnica?.toString(),
      true
    )
      .then((data) => {
        if (data?.Result?.ListaProdutos?.length !== 0) {
          const newList = [];
          let newObject = {};

          if (showcaseList?.length !== 0 || showcaseItemsList?.length !== 0) {
            let verifyPreviousSelected = [];
            let previousItemObject = {};
            const previousItemList = [];

            if (showcaseItemsList?.length !== 0) {
              verifyPreviousSelected = data?.Result?.ListaProdutos.filter(
                (newData) =>
                  showcaseItemsList.filter(
                    (selected) => selected?.Codigo === newData?.Codigo
                  )?.length
              );
            } else if (showcaseList?.length !== 0) {
              verifyPreviousSelected = data?.Result?.ListaProdutos.filter(
                (newData) =>
                  showcaseList.filter(
                    (selected) => selected?.Codigo === newData?.Codigo
                  )?.length
              );
            }

            if (verifyPreviousSelected?.length !== 0) {
              verifyPreviousSelected?.map((item) => {
                previousItemObject = {
                  Codigo: item?.Codigo,
                  Ean: item?.Ean,
                  EstoqueDisponivel: item?.EstoqueDisponivel,
                  Foto: item?.Foto,
                  FotoPrincipal: item?.FotoPrincipal,
                  ListaProduto: item?.ListaProduto,
                  Nome: item?.Nome?.toUpperCase(),
                  QuantidadeEstoque: item?.QuantidadeEstoque,
                  QuantidadeEstoqueFormat: item?.QuantidadeEstoqueFormat,
                  Disabled: true,
                };
                previousItemList?.push(previousItemObject);
              });
            }

            const compareItems = data?.Result?.ListaProdutos.filter(function (
              cv
            ) {
              return !verifyPreviousSelected.find(function (e) {
                return e.Codigo === cv.Codigo;
              });
            });

            compareItems?.map((item) => {
              newObject = {
                Codigo: item?.Codigo,
                Ean: item?.Ean,
                EstoqueDisponivel: item?.EstoqueDisponivel,
                Foto: item?.Foto,
                FotoPrincipal: item?.FotoPrincipal,
                ListaProduto: item?.ListaProduto,
                Nome: item?.Nome?.toUpperCase(),
                QuantidadeEstoque: item?.QuantidadeEstoque,
                QuantidadeEstoqueFormat: item?.QuantidadeEstoqueFormat,
                Disabled: false,
              };
              newList?.push(newObject);
            });

            const newArray = previousItemList?.concat(newList);
            setProductsList(newArray);
          } else {
            data?.Result?.ListaProdutos?.map((item) => {
              newObject = {
                Codigo: item?.Codigo,
                Ean: item?.Ean,
                EstoqueDisponivel: item?.EstoqueDisponivel,
                Foto: item?.Foto,
                FotoPrincipal: item?.FotoPrincipal,
                ListaProduto: item?.ListaProduto,
                Nome: item?.Nome?.toUpperCase(),
                QuantidadeEstoque: item?.QuantidadeEstoque,
                QuantidadeEstoqueFormat: item?.QuantidadeEstoqueFormat,
                Disabled: false,
              };
              newList?.push(newObject);
            });
            setProductsList(newList);
          }
        } else {
          setProductsList([]);
        }
        setTotalRegisters(data?.Result?.TotalRegistros);
        setOpenProductDialog(true);
      })
      .catch((e) => {
        console.log(e);
        snackbar.showMessage(e, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "159",
          screen: "Vitrine Virtual",
          problem: `Erro na chamada do endpoint product-simple-list - ${e}`,
        });
      })
      .finally(() => {
        setCurrentPage(page);
        setSearchingProducts(false);
      });
  };

  const handleEditShowcase = async () => {
    const idList = [];
    setEditingShowcase(true);

    showcaseItemsList?.map((product) => idList?.push(product?.Codigo));

    await Api.put(
      "edit-virtual-showcase",
      "showcase",
      {
        nome: showcaseName,
        ativo: active.toString(),
        dataVigenciaInicio: UtilsFncs.ConvertDateFormat(initialDate, "/", "-"),
        dataVigenciaFim: UtilsFncs.ConvertDateFormat(finalDate, "/", "-"),
        idPessoaLoja: structureFilters?.idLojaUnica?.toString(),
        idVitrineVirtual: data?.IdVitrineVirtual,
        idsProduto: idList.join(","),
      },
      true
    )
      .then((resp) => {
        if (resp?.Success) {
          snackbar.showMessage(resp?.Result?.MessageResponse, {
            severity: "success",
          });
          handleClose("edit");
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "159",
          screen: "Vitrine Virtual",
          problem: `Erro na chamada do endpoint edit-virtual-showcase - ${error}`,
        });
      })
      .finally(() => setEditingShowcase(false));
  };

  const modelTableItemDetail = [
    {
      dataField: "Foto",
      text: "Produto",
      align: "center",
      headerAlign: "center",
      isDummyField: true,
      formatter: (cell, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ImagePlaceholder
            src={row.Foto}
            alt="Foto do produto"
            width={50}
            widthOnError={40}
            imagePreviewTitle={""}
          />
        </div>
      ),
      csvExport: true,
    },
    columnTextField(
      {
        dataField: "Nome",
        text: "Descrição",
        align: "left",
        formatter: (cell) => {
          return <p style={{ whiteSpace: "normal" }}>{cell}</p>;
        },
      },
      false
    ),
    {
      dataField: "deletar",
      text: "",
      isDummyField: true,
      headerStyle: { width: 45 },
      formatter: (cell, row) => (
        <Tooltip title="Remover Produto">
          <IconButton
            aria-label="delete"
            onClick={() => {
              setShowcaseItemsList((prevState) =>
                prevState.filter((item) => item?.Codigo !== row?.Codigo)
              );

              setProductsList((prevState) =>
                prevState?.map((item) => {
                  if (item.Codigo === row.Codigo) {
                    return {
                      ...item,
                      Disabled: false,
                    };
                  } else {
                    return item;
                  }
                })
              );
            }}
          >
            <Box
              component={DeleteIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    if (data?.Itens) {
      const newList = [];
      let newObject = {};

      data?.Itens?.map((item) => {
        newObject = {
          Codigo: item?.IdProduto,
          Foto: item?.Foto,
          FotoPrincipal: item?.Foto,
          Nome: item?.DescricaoProduto,
          Disabled: true,
        };
        newList?.push(newObject);
      });
      setShowcaseItemsList(newList);
      setInitialDate(data?.DataVigenciaInicioFormat);
      setFinalDate(data?.DataVigenciaFimFormat);
    }
  }, []);

  return (
    <Dialog
      maxWidth="lg"
      open
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle>
        <Typography variant="h3" component="h3">
          Editar Vitrine Virtual
        </Typography>
      </DialogTitle>

      <DialogContent style={{ padding: "1rem 2rem", overflowX: "hidden" }}>
        <PerfectScrollbar>
          <Grid container>
            <Grid item xs={itemSM}>
              <FromToDateField
                isMobile900={isMobile500}
                label={"Vigência"}
                searching={false}
                initialDate={initialDate}
                finalDate={finalDate}
                setFinalDate={setFinalDate}
                setInitialDate={setInitialDate}
              />
            </Grid>

            <Grid item xs={itemSM}>
              <FormGroup>
                <FormLabel>Nome Vitrine</FormLabel>
                <TextField
                  name="nome"
                  required
                  multiline
                  fullWidth
                  value={showcaseName}
                  variant="outlined"
                  onChange={(e) => {
                    setShowcaseName(e.target.value);
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.toString().slice(0, 100);
                  }}
                />
              </FormGroup>
            </Grid>

            <StructureFields
              showSingleStore={true}
              onStructureFieldsChange={setStructureFilters}
              disableAll={structureLoading?.length !== 0}
              onStructureFieldsLoad={setStructureLoading}
              requiredFields={["storeSingle"]}
              fieldsOrder={["storeSingle"]}
              hideFields={[
                "channel",
                "representative",
                "economicGroup",
                "store",
                "brand",
              ]}
              removeBrandAll={true}
              singleStoreId={data?.IdPessoaLoja}
            />

            <Grid item xs={2}>
              <FormGroup>
                <FormLabel>Status</FormLabel>
                <FormControlLabel
                  style={{ marginLeft: 0 }}
                  control={
                    <Switch
                      checked={active}
                      onChange={(e) => setActive(e.target.checked)}
                      size="small"
                    />
                  }
                  label={active ? "Ativa" : "Inativa"}
                  labelPlacement="end"
                  value="end"
                  classes={{
                    root: classes.formControlLabelRoot,
                    label: classes.formControlLabelLabel,
                  }}
                />
              </FormGroup>
            </Grid>

            <Grid
              item
              xs={itemXS}
              style={{ marginLeft: "auto", marginRight: "0.5rem" }}
            >
              <Button
                style={{
                  width: "100%",
                  marginTop: isMobile500 ? "-0.5rem" : "0.65rem",
                  marginBottom: isMobile500 ? "1rem" : 0,
                }}
                variant="contained"
                onClick={() =>
                  setShowAddProductsContainer(!showAddProductsContainer)
                }
                disabled={searchingProducts}
                fullWidth
              >
                Adicionar produtos
              </Button>
            </Grid>
          </Grid>

          <Grid container hidden={!showAddProductsContainer}>
            <Grid item xs={12}>
              <Divider style={{ margin: "0.5rem 0 2rem" }} />
            </Grid>

            <Grid item xs={itemXS}>
              <FormGroup>
                <FormLabel>Produto</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  value={productFilter}
                  onChange={(e) => {
                    setProductFilter(e.target.value);
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.toString().slice(0, 100);
                  }}
                />
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
              }}
            >
              <Button
                variant="contained"
                onClick={handleGetProducts}
                disabled={
                  searchingProducts || productFilter === ""
                  // selectedCategorie === ''
                }
                fullWidth
              >
                {searchingProducts ? "Pesquisando..." : "Pesquisar"}
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ display: "flex", alignItems: "center" }}
              hidden={openProductDialog || productsList?.length === 0}
            >
              <Button
                className={classes.buttonStyle}
                style={
                  isMobile500 || isMobile900
                    ? {
                        width: "100%",
                        marginBottom: "0.5rem",
                        marginTop: "0.75rem",
                      }
                    : { marginBottom: "0rem" }
                }
                onClick={() => setOpenProductDialog(true)}
              >
                Ver Produtos
              </Button>
            </Grid>
            <Grid item xs={12}>
              {searchingProducts && !openProductDialog && (
                <div>
                  <span>Buscando produtos...</span>
                  <LinearProgress />
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <Divider style={{ margin: "0.5rem 0 2rem" }} />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} hidden={showcaseItemsList?.length === 0}>
              <ToolkitProvider
                data={showcaseItemsList}
                keyField={"Codigo"}
                columns={modelTableItemDetail}
              >
                {(props) => (
                  <PerfectScrollbar>
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      condensed={true}
                      striped={true}
                      hover={true}
                      style={{ overflow: "auto!important" }}
                    />
                  </PerfectScrollbar>
                )}
              </ToolkitProvider>
            </Grid>
            <Grid item xs={12} hidden={showcaseItemsList?.length !== 0}>
              <Typography
                variant="h5"
                component="h5"
                style={{ color: "grey", marginTop: "2rem" }}
              >
                <i
                  className="fa fa-exclamation-circle"
                  aria-hidden="true"
                  style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                />{" "}
                É necessário selecionar produtos para a Vitrine Virtual.
              </Typography>
            </Grid>
          </Grid>

          {productsList?.length !== 0 && openProductDialog && (
            <TableProductsList
              dataTable={productsList}
              search={handleGetProducts}
              currentPage={currentPage}
              totalRegistros={totalRegisters}
              setShowcaseItemsList={setShowcaseItemsList}
              showcaseItemsList={showcaseItemsList}
              setProductsList={setProductsList}
              searchingProducts={searchingProducts}
              open={openProductDialog}
              onClose={() => {
                setOpenProductDialog(false);
              }}
            />
          )}
        </PerfectScrollbar>
      </DialogContent>

      <DialogActions>
        <Grid item xs={12} hidden={!editingShowcase}>
          {editingShowcase && (
            <div>
              <span>Atualizando Vitrine Virtual...</span>
              <LinearProgress />
            </div>
          )}
        </Grid>
        <Button component={Box} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleEditShowcase}
          disabled={
            editingShowcase ||
            searchingProducts ||
            UtilsFncs.ConvertDateFormat(finalDate, "/", "-") <
              UtilsFncs.ConvertDateFormat(initialDate, "/", "-")
          }
        >
          {editingShowcase ? "Atualizando..." : "Atualizar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { DialogEditShowcase };
